import { FormControl } from '@mui/material';
import { Button, TextField } from '@mui/material';
import React from 'react';
import ApiServices from '../services/ApiServices';


function DeviceUpload(props) {

    const { handleSubmit } = props
    const [file, setFile] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    const handleFormSubmit = e => {
        e.preventDefault();
        setLoading(true);
        ApiServices.uploadDevices(file)
            .then(response => {
                if (response.status === 200) {
                    handleSubmit("success", response.data);
                } else {
                    handleSubmit("error", response.data);
                }
            })
            .catch(error => {
                handleSubmit("error", error.response?.data ?? error.message);
                console.error(error);
            })
            .finally(() => setLoading(false));
    }

    const handleInput = event => {
        setFile(event.target.files[0]);
    }

    return (
        <form onSubmit={handleFormSubmit} sx={{ display: "flex", flexWrap: "wrap" }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
                <TextField required name="file" label="File" type="file" variant="standard" onChange={handleInput} inputProps={{ accept: "application/csv" }} />
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
                <Button variant="contained" color="primary" type='submit' disabled={loading}>
                    {loading ? "Uploading..." : "Submit"}
                </Button>
            </FormControl>
        </form>
    )
}

export default DeviceUpload